import { ApolloClient, InMemoryCache, createHttpLink, ApolloLink } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { getApiConfig } from '../../../../lib/config';

const apiConfig = getApiConfig();

const httpLink = createHttpLink({
  uri: apiConfig.mtcmDbUrl
});

// Function to get the current Keycloak token
let getToken: (() => string | undefined) | null = null;

export const setTokenGetter = (tokenGetter: () => string | undefined) => {
  getToken = tokenGetter;
};

const authLink = setContext((_, { headers }) => {
  const token = getToken?.();
  
  return {
    headers: {
      ...headers,
      ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

export default client;
